<template>
  <FormKit
    id="move-form"
    v-model="values"
    #="{ state: { valid } }"
    type="form"
    form-class="grid devis-form"
    :actions="false"
    :incomplete-message="false"
  >
    <div class="g-col-12">
      <div class="grid">
        <FormKit
          id="moveDate"
          type="text"
          name="moveDate"
          outer-class="g-col-12 g-col-lg-6 required"
          validation="required"
          validation-visibility="submit"
          input-class="smdt-input smdt-input--icon smdt-input--icon--calendar devis-date"
          :label="__('Desired moving period (minimum 15 days):', 'smdt')"
          :placeholder="__('Between : xx/xx/xxxx and xx/xx/xxxx', 'smdt')"
          :value="values.moveDate"
        />
      </div>
    </div>
    <div class="g-col-12">
      <p style="margin-bottom: 10px;color: var(--vn-secondary-color);font-weight: bold;font-size: 16px" v-html="__('If you know the total volume of your belongings to be moved, you will skip the inventory step.', 'smdt')"></p>
    </div>
    <FormKit
      id="moveMeter"
      type="number"
      name="moveMeter"
      outer-class="g-col-12 g-col-lg-6"
      validation="number"
      input-class="smdt-input--icon smdt-input--icon--meter"
      :label="__('Volume in m³:', 'smdt')"
      placeholder="xxxxxxxxxxx"
      :value="values.moveMeter"
    />
    <FormKit
        id="moveFurniture"
        type="text"
        name="moveFurniture"
        outer-class="g-col-12 g-col-lg-6"
        validation="number"
        input-class="smdt-input--icon smdt-input--icon--eur"
        :label="__('Value of furniture to be moved:', 'smdt')"
        placeholder="xxxxxxxxxxx"
        :value="values.moveFurniture"
    />
    <div class="g-col-12">
      <div class="devis-btn-group">
        <button
          type="button"
          class="devis-btn devis-btn--white"
          @click="goStep(1)"
        >
          {{ __('Previous step', 'smdt') }}
        </button>
        <button
          type="button"
          class="devis-btn"
          :disabled="!valid"
          @click="goStep(values.moveMeter ? 4 : 3)"
        >
          {{ __('Next step', 'smdt') }}
        </button>
      </div>
    </div>
  </FormKit>
</template>

<script>
import { easepick } from '@easepick/core'
import { RangePlugin } from '@easepick/range-plugin'
import { mapActions, mapState, mapWritableState } from 'pinia'
import { useStagesStore } from '../stores/stages'
import { LockPlugin } from '@easepick/bundle'
import { getNode } from '@formkit/core'
import moment from 'moment'
import { watch } from 'vue'

// eslint-disable-next-line no-undef
const themeObject = devisObject

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

export default {
  name: 'StageThree',
  props: {
    stage: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapWritableState(useStagesStore, ['values', 'currentStep']),
    ...mapState(useStagesStore, [
      'apiData',
      'currentStageData',
      'updateState',
      'updateValues',
    ]),
    subtitle() {
      const { title, subtitle } = this.currentStageData
      return `${title} ${subtitle}`
    },
  },
  mounted() {
    const node = this.$formkit.get('move-form')
    const isValid = node.context.state

    watch(isValid, (val) => {
      const { valid } = val
      this.setValid(valid)
    })

    const input = document.querySelector('.devis-date')
    const moveDate = getNode('moveDate')

    const params = new URLSearchParams(window.location.search)
    let startDate, endDate
    if (params.has('start') && params.has('end')) {
      const start = params.get('start')
      const end = params.get('end')

      startDate = moment.unix(start).format('DD/MM/YYYY')
      endDate = moment.unix(end).format('DD/MM/YYYY')

      moveDate.input(`${startDate} - ${endDate}`)
    }

    new easepick.create({
      element: input,
      css: [themeObject.easepick],
      lang: 'fr-FR',
      plugins: [RangePlugin, LockPlugin],
      grid: 2,
      calendars: 2,
      format: 'DD/MM/YYYY',
      RangePlugin: {
        tooltipNumber(num) {
          return num - 1
        },
        locale: {
          one: this.vals.day,
          other: this.vals.days,
        },
        startDate,
        endDate,
      },
      LockPlugin: {
        minDays: 15,
        minDate: new Date(),
      },
      setup(picker) {
        picker.on('select', () => {
          moveDate.input(input.value)
        })
      },
    })
  },
  methods: {
    ...mapActions(useStagesStore, ['setValid', 'goStep']),
    __,
  },
}
</script>

<style scoped lang="scss"></style>
